__turbopack_context__.v({
  "button": "tertiary-module-scss-module__uHW3EG__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "tertiary-module-scss-module__uHW3EG__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "tertiary-module-scss-module__uHW3EG__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "tertiary-module-scss-module__uHW3EG__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "tertiary-module-scss-module__uHW3EG__small" + " " + __turbopack_context__.i(693367)["small"],
});
